
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useRoleAccessConfig } from './role-access/hooks/useRoleAccessConfig';
import { useRoleAccessActions } from './role-access/hooks/useRoleAccessActions';
import { RoleAccessActions } from './role-access/components/RoleAccessActions';
import { RoleAccessTable } from './role-access/components/RoleAccessTable';
import { RoleAccessManagerProps } from './role-access/types';

export function RoleAccessManager({ className }: RoleAccessManagerProps) {
  const { accessConfig, setAccessConfig, handleAccessChange } = useRoleAccessConfig();
  const { isSaving, handleSave, handleReset, handleExport, handleImport } = useRoleAccessActions(
    accessConfig,
    setAccessConfig
  );

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>Role-Based Access Control</CardTitle>
        <CardDescription>
          Define which pages each role can access in the system
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RoleAccessActions
          isSaving={isSaving}
          onSave={handleSave}
          onReset={handleReset}
          onExport={handleExport}
          onImport={handleImport}
        />
        
        <RoleAccessTable
          accessConfig={accessConfig}
          onAccessChange={handleAccessChange}
        />
        
        <p className="text-sm text-muted-foreground mt-4">
          Note: Changes to role access will take effect immediately after saving. The Admin role will always have access to the Dashboard.
        </p>
      </CardContent>
    </Card>
  );
}
